import { SalesProcessNote } from '@app/models/sales-process-note'
import { State, Action, StateContext, Selector, createSelector } from '@ngxs/store'
import { SalesProcessToolAction } from './sales-process-tool.actions';
import hardCodedSalesProcessToolNotes from '@app/constants/sales-process-tool-notes.json'
import { Injectable } from '@angular/core';
import { patch, updateItem } from '@ngxs/store/operators';
import { RouterState, RouterStateModel } from '@ngxs/router-plugin';

export interface SalesProcessToolStateModel {
    salesProcessToolNotes: SalesProcessNote[];
}

const defaults = {
    salesProcessToolNotes: hardCodedSalesProcessToolNotes.filter((note) => !note.brand)
}


@State<SalesProcessToolStateModel>({
    name: 'salesProcessTool',
    defaults
})

@Injectable()
export class SalesProcessToolState {
    constructor () {}

    @Action(SalesProcessToolAction.ResetState)
    resetNoteState({ setState }: StateContext<SalesProcessToolStateModel>) {
        setState({
            salesProcessToolNotes: hardCodedSalesProcessToolNotes.filter((note) => !note.brand)
        }); 
    }

    @Action(SalesProcessToolAction.LoadBrandedNotes)
    loadBrandedNotes(
        { setState }: StateContext<SalesProcessToolStateModel>,
        { payload }: SalesProcessToolAction.LoadBrandedNotes
    ) {
        if (!payload) return;
        
        setState({
            salesProcessToolNotes: hardCodedSalesProcessToolNotes.filter(
                (note) => !note.brand || note.brand.toLowerCase() === payload.toLowerCase()
            )
        });
    }


    @Action(SalesProcessToolAction.ToggleNoteRead)
    setNoteRead(
        { setState }: StateContext<SalesProcessToolStateModel>,
        { payload }: SalesProcessToolAction.ToggleNoteRead
    ) {
        if (!payload) return;
        setState(
            patch<SalesProcessToolStateModel>({
                salesProcessToolNotes: updateItem<SalesProcessNote>(
                    (n) => n?.id === payload,
                    (s) => ({
                        ...s,
                        hasBeenRead: !s.hasBeenRead
                    })
                )
            })
        );       
    }
    
    static currentPageNotes() {
        return createSelector([SalesProcessToolState, RouterState], (salesProcessState: SalesProcessToolStateModel, routerState: RouterStateModel) => {
            return salesProcessState.salesProcessToolNotes
                .filter((note) => note.page === routerState.state?.url && !note.brand)
                .sort((a, b) => a.sortOrder - b.sortOrder); 
        })
    }

    static currentPageBrandedNotes() {
        return createSelector([SalesProcessToolState, RouterState], (salesProcessState: SalesProcessToolStateModel, routerState: RouterStateModel) => {
            return salesProcessState.salesProcessToolNotes
                .filter((note) => note.page === routerState.state?.url && !!note.brand)
                .sort((a, b) => a.sortOrder - b.sortOrder); 
        })
    }
}